import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47241d44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row align-items-center flex-row justify-content-between custom-mobile" }
const _hoisted_2 = { class: "col-auto" }
const _hoisted_3 = { class: "header-left-side justify-content-center justify-content-md-start d-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-menu-3" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "col-auto area-buttons-header" }
const _hoisted_7 = { class: "header-right-side d-flex align-items-center justify-content-end" }
const _hoisted_8 = { class: "dropdown notification-dropdown security-notification-dropdown" }
const _hoisted_9 = {
  type: "button",
  class: "security-notification-toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false",
  "aria-label": "Notificações de alertas da IA",
  title: "Alertas da IA"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-bell" }, null, -1))
const _hoisted_11 = {
  key: 0,
  class: "security-notification-badge"
}
const _hoisted_12 = { class: "dropdown-menu security-notification-menu bg-white border-0 radius-7" }
const _hoisted_13 = { class: "security-notification-header" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Alertas da IA"),
  /*#__PURE__*/_createElementVNode("span", null, "Últimas detecções")
], -1))
const _hoisted_15 = {
  key: 0,
  class: "security-notification-loading"
}
const _hoisted_16 = {
  key: 0,
  class: "security-notification-list list-unstyled mb-0"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "security-notification-image" }
const _hoisted_19 = ["src", "alt", "onError"]
const _hoisted_20 = {
  key: 1,
  class: "ph ph-camera-slash"
}
const _hoisted_21 = { class: "security-notification-content" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Pessoa detectada", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-caret-right security-notification-arrow" }, null, -1))
const _hoisted_24 = {
  key: 1,
  class: "security-notification-empty"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-bell-slash" }, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Nenhum alerta disponível.", -1))
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = { class: "profile-dropdown d-flex justify-content-end" }
const _hoisted_29 = {
  class: "text-end fs-14 text-black-emphasis d-flex align-items-center p-0 position-relative bg-transparent border-0 transition lh-1",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_30 = { class: "title d-lg-block" }
const _hoisted_31 = { class: "d-block fw-bold" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-body-emphasis fw-semibold fs-13" }, "Config", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dropdown dropdown-menu rounded-0 bg-white border-0 end-0 ps-10 radius-7" }, [
  /*#__PURE__*/_createElementVNode("ul", { class: "ps-0 mb-0 list-unstyled dropdown-body" }, [
    /*#__PURE__*/_createElementVNode("li", {
      class: "pointer text-body-secondary fw-semibold transition position-relative",
      "data-bs-toggle": "modal",
      "data-bs-target": "#verticallyCenteredModal"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "flaticon-logout" }),
      /*#__PURE__*/_createTextVNode(" Deslogar ")
    ])
  ])
], -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-x" }, null, -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "global-security-alert-kicker" }, "Alerta IA ao vivo", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "global-security-alert-title" }, "Pessoa detectada", -1))
const _hoisted_38 = { class: "global-security-alert-frame" }
const _hoisted_39 = ["src", "alt"]
const _hoisted_40 = {
  key: 1,
  class: "global-security-alert-frame-empty"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ph ph-camera-slash" }, null, -1))
const _hoisted_42 = { class: "global-security-alert-camera" }
const _hoisted_43 = { class: "global-security-alert-meta" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "global-security-alert-action" }, [
  /*#__PURE__*/_createTextVNode(" Abrir no mosaico "),
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-arrow-right" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogoutModal = _resolveComponent("LogoutModal")!
  const _component_LightDarkSwtichBtn = _resolveComponent("LightDarkSwtichBtn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_LogoutModal),
    _createElementVNode("header", {
      class: _normalizeClass([
      'header-area bg-white text-center text-md-start pt-15 pb-15 ps-15 pe-15 ps-md-20 pe-md-20 pe-lg-30 transition mb-25 position-fixed radius-7',
      { sticky: _ctx.isSticky },
    ]),
      id: "header"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "header-burger-menu transition position-relative lh-1 bg-transparent p-0 border-0",
              id: "header-burger-menu",
              "aria-label": "Abrir ou fechar menu",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args)))
            }, _hoisted_5)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_LightDarkSwtichBtn),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", _hoisted_9, [
                _hoisted_10,
                (_ctx.recentSecurityAlerts.length)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.recentSecurityAlerts.length), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  (_ctx.notificationsLoading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Carregando..."))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.recentSecurityAlerts.length)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentSecurityAlerts, (alert) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: alert.alert_id
                        }, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "security-notification-item",
                            onClick: ($event: any) => (_ctx.navigateToSecurityAlert(alert))
                          }, [
                            _createElementVNode("span", _hoisted_18, [
                              (_ctx.hasSnapshot(alert))
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: alert.snapshot_url,
                                    alt: `Detecção na câmera ${alert.camera_name || 'sem nome'}`,
                                    onError: ($event: any) => (_ctx.markSnapshotUnavailable(alert))
                                  }, null, 40, _hoisted_19))
                                : (_openBlock(), _createElementBlock("i", _hoisted_20))
                            ]),
                            _createElementVNode("span", _hoisted_21, [
                              _createElementVNode("strong", null, _toDisplayString(alert.camera_name || 'Câmera'), 1),
                              _hoisted_22,
                              _createElementVNode("small", null, [
                                _createTextVNode(_toDisplayString(_ctx.formatSecurityAlertDate(alert.detected_at)) + " ", 1),
                                (alert.confidence)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(" · " + _toDisplayString(_ctx.formatConfidence(alert.confidence)), 1)
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _hoisted_23
                          ], 8, _hoisted_17)
                        ]))
                      }), 128))
                    ]))
                  : (!_ctx.notificationsLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_27))
                    : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("button", _hoisted_29, [
                _createElementVNode("span", _hoisted_30, [
                  _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.getConfigurations.name), 1),
                  _hoisted_32
                ])
              ]),
              _hoisted_33
            ])
          ])
        ])
      ])
    ], 2),
    _createVNode(_Transition, { name: "security-alert-pop" }, {
      default: _withCtx(() => [
        (_ctx.activeSecurityAlert && _ctx.$route.path !== '/realtime')
          ? (_openBlock(), _createElementBlock("aside", {
              key: 0,
              class: "global-security-alert",
              role: "button",
              tabindex: "0",
              title: "Abrir esta câmera no mosaico",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.navigateToSecurityAlert(_ctx.activeSecurityAlert))),
              onKeydown: [
                _cache[4] || (_cache[4] = _withKeys(_withModifiers(($event: any) => (_ctx.navigateToSecurityAlert(_ctx.activeSecurityAlert)), ["prevent"]), ["enter"])),
                _cache[5] || (_cache[5] = _withKeys(_withModifiers(($event: any) => (_ctx.navigateToSecurityAlert(_ctx.activeSecurityAlert)), ["prevent"]), ["space"]))
              ]
            }, [
              _createElementVNode("button", {
                type: "button",
                class: "global-security-alert-close",
                "aria-label": "Fechar alerta",
                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.dismissActiveSecurityAlert && _ctx.dismissActiveSecurityAlert(...args)), ["stop"]))
              }, _hoisted_35),
              _hoisted_36,
              _hoisted_37,
              _createElementVNode("div", _hoisted_38, [
                (_ctx.hasSnapshot(_ctx.activeSecurityAlert))
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.activeSecurityAlert.snapshot_url,
                      alt: `Detecção na câmera ${_ctx.activeSecurityAlert.camera_name || 'sem nome'}`,
                      onError: _cache[2] || (_cache[2] = ($event: any) => (_ctx.markSnapshotUnavailable(_ctx.activeSecurityAlert)))
                    }, null, 40, _hoisted_39))
                  : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      _hoisted_41,
                      _createTextVNode(" Imagem indisponível ")
                    ]))
              ]),
              _createElementVNode("strong", _hoisted_42, _toDisplayString(_ctx.activeSecurityAlert.camera_name || 'Câmera'), 1),
              _createElementVNode("span", _hoisted_43, [
                _createTextVNode(_toDisplayString(_ctx.formatSecurityAlertDate(_ctx.activeSecurityAlert.detected_at)) + " ", 1),
                (_ctx.activeSecurityAlert.confidence)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" · confiança " + _toDisplayString(_ctx.formatConfidence(_ctx.activeSecurityAlert.confidence)), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_44
            ], 32))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}